<template>
  <div class="fixed-box" @click.stop :style="{'top': jobTabCardDialogTop + 'px'}" @mouseenter="showFixed" @mouseleave="hiddenFixed">

    <div class="fixed-title">
      <span>{{ cardData.job_post }}</span>
      <span>{{ cardData.display_salary }}</span>
    </div>

    <div class="fixed-tags">
      <span class="tag-menu">{{(cardData.city_names && cardData.city_names[0]) || '全国'}}</span>
      <span class="tag-menu" v-if="cardData.job_nature === '校招'">{{ cardData.job_nature }}</span>
      <span class="tag-menu" v-if="cardData.job_nature === '全职'">{{!cardData.display_experience || cardData.display_experience === '不限' ? '经验不限' : (cardData.display_experience === '1年以下' ? '1年以内' : cardData.display_experience)}}</span>
      <span class="tag-menu" v-if="cardData.job_nature === '校招'">{{ cardData.graduate_times | formatGraduationYear }}</span>
      <span class="tag-menu">{{!cardData.degree_name || cardData.degree_name === '不限' ? '学历不限' : cardData.degree_name}}</span>
      <span class="tag-menu" v-if="cardData.intern_frequency && cardData.job_nature === '实习'">{{ `${cardData.intern_frequency}天/周` }}</span>
      <span class="tag-menu" v-if="cardData.intern_duration && cardData.job_nature === '实习'">{{ cardData.intern_duration }}</span>
      <template v-for="(tagItem, tagIndex) in (cardData.job_tags || [])">
        <span class="tag-menu" :key="'tag-menu' + tagIndex">{{tagItem}}</span>
      </template>
    </div>

    <div class="fixed-company">
      <img :src="cardData.company_logo" alt="">
      <span v-if="cardData.company_nick_name">{{ cardData.company_nick_name }}</span>
      <span v-if="cardData.company_industry">{{ cardData.company_industry }}</span>
      <span v-if="cardData.phase">{{ cardData.phase }}</span>
    </div>

    <div class="fixed-jd">
      <span>经验要求</span>
      <p v-html="cardData.jd"></p>
    </div>

    <div class="fixed-btn-box">
      <div class="fixed-btn" @click="debounce(delivery, 300)" data-growing-container data-growing-idx="506">投递简历</div>
      <div class="fixed-btn" @click="debounce(createReport, 300)" data-growing-container data-growing-idx="507">查看优化建议</div>
    </div>

  </div>
</template>

<script>
import api from '@/api'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  props: {
    // 卡片数据
    cardData: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ...mapState('editor', [ 'jobTabCardDialogTop', 'showJobTabCardDialog', 'showJobTabCardDialogSelf'])
  },
  filters: {
    formatGraduationYear (yearArr) {
      if (!yearArr || !yearArr.length) return ''
      let newArr = yearArr.map(item => {
        return String(item).substring(2)
      })
      return newArr.join('/') + '届'
    }
  },
  methods: {
    ...mapMutations('editor', ['setJobTabCardDialogTimer', 'setShowJobTabCardDialog', 'setShowJobTabCardDialogSelf']),

    showFixed () {
      this.setShowJobTabCardDialogSelf(true)
    },
    hiddenFixed () {
      this.setShowJobTabCardDialogSelf(false)
    },
    // 投递简历
    delivery () {
      this.$emit('delivery')
    },
    // 创建报告
    createReport () {
      this.$emit('createReport')
    },
    // 防抖
    debounce (fn, timeInterval) {
			if (this.timer) {
				clearTimeout(this.timer)
			}
			let arg = [ ...arguments ].filter((item, index) => {
				return index > 1
			})
			this.timer = setTimeout(() => {
				fn.apply(this, arg)
			}, timeInterval)
		}
  }
}
</script>

<style lang="scss" scoped>
  .fixed-box {
    cursor: default;
    position: absolute;
    top: 142px;
    right: -290px;
    z-index: 3;
    width: 300px;
    background: #fff;
    box-shadow: 0px 2px 16px 0px rgba(10, 44, 156, 0.14);
    border-radius: 6px;
    padding: 16px 0 0;

    .fixed-title {
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;

      >span:first-of-type {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #404040;
        line-height: 22px;
        max-width: 170px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      >span:last-of-type {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF6644;
        line-height: 22px;
      }
    }

    .fixed-tags {
      padding: 0 16px;
      display: flex;
      margin-bottom: 6px;

      display: flex;
      flex-wrap: wrap;
      height: 21px;
      overflow: hidden;

      >span {
        padding: 2px 6px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 17px;
        background: #F9F9F9;
        border-radius: 4px;
        margin-right: 6px;

        &:last-of-type {
          margin-right: 0;
        }
      }
    }

    .fixed-company {
      margin: 0 16px;
      display: flex;
      align-items: center;
      padding-bottom: 16px;
      border-bottom: 1px solid #f9f9f9;

      >img {
        width: 24px;
        height: 24px;
        border-radius: 2px;
        border: 1px solid #ECECEC;
        margin-right: 8px;
      }

      &>span {
        padding: 0 6px;
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 14px;
        position: relative;
        overflow: hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
        &::after{
          content: "";
          height:9px;
          width: 1px;
          background-color: #cfcfcf;
          position: absolute;
          right:0;
          top: 3px
        }
        &:last-child::after{
          display: none;
        }
      }
    }

    .fixed-jd {
      height: 170px;
      overflow-y: auto;
      padding: 16px 16px 0;

      >span {
        display: block;
        font-size: 13px;
        font-weight: 400;
        color: #9C9C9C;
        line-height: 14px;
        margin-bottom: 10px;
      }

      >p {
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 20px;
      }
    }

    .fixed-btn-box {
      display: flex;
      justify-content: space-between;
      padding: 10px 16px 16px;

      .fixed-btn {
        cursor: pointer;
        width: 130px;
        height: 36px;
        border-radius: 18px;
        line-height: 36px;
        text-align: center;

        &:hover {
          opacity: 0.8;
        }

        &:first-of-type {
          font-size: 14px;
          font-weight: 400;
          color: #FF6644;
          border: 1px solid #ff6644;
        }

        &:last-of-type {
          background: linear-gradient(135deg, #FFA75E 0%, #FF6644 100%);
          font-size: 14px;
          font-weight: 500;
          color: #FFFFFF;

        }
      }
    }

  }
</style>
